<div class="line-item">
  <div class="line-item__name">
    <span>
      <span *ngIf="planData">{{ "payment-info.line-item.plan" | translate }}</span>
      {{ item.description }}
      <!-- For plans we need to show quantity right after the description as we don't have additional data -->
      <span *ngIf="!showItemData && showItemQuantity" class="line-item__data line-item__data--plan">
        &nbsp;{{"payment-info.line-item.quantity" | translate: {quantity: item.quantity} }}
      </span>
    </span>
    <div *ngIf="showItemData" class="line-item__data line-item__data--addon">
      <span>({{item.unit_amount | countryCurrency: currency:'symbol':'1.1-3':locale}}</span>
      <span>{{"payment-info.line-item.per_each" | translate}})</span>
      <span *ngIf="showItemQuantity" class="line-item__quantity">&nbsp;{{"payment-info.line-item.quantity" | translate: {quantity: item.quantity} }}</span>
    </div>
  </div>
  <div class="line-item__price">
    <!-- If there is some discount we show the "full-price" crossed out by a line
    in all other cases the price is the "discounted-price" -->
    <span class="full-price" *ngIf="planData?.meta_data.pricing_info.discount_amount">
      {{planFullPrice | countryCurrency: currency:'symbol':'1.1-3':locale}}
    </span>
    <span class="discounted-price">{{item.total_amount | countryCurrency: currency:'symbol':'1.1-3':locale}}
    </span>
  </div>
</div>